import { render } from "./productPageSummary.vue?vue&type=template&id=db3e845a&scoped=true&ts=true"
import script from "./productPageSummary.vue?vue&type=script&lang=ts"
export * from "./productPageSummary.vue?vue&type=script&lang=ts"

import "./productPageSummary.vue?vue&type=style&index=0&id=db3e845a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db3e845a"]])

export default __exports__